<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="510">
      <template #activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          :ripple="false"
          :small="small"
          color="warning"
          outlined
          v-on="on">
          Ad Event คืออะไร
          <v-icon right>
            mdi-help-circle
          </v-icon>
        </v-btn>
      </template>
      <v-card color="pa-2">
        <v-card-title>
          <div class="text-h2-headline primary--text">
            Ad Event คืออะไร
          </div>
          <v-spacer />
          <v-btn
            icon
            small
            @click="setDialog(false)">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ตัวช่วยที่จะทำให้การซื้อโฆษณาของร้านค้ามีประสิทธิภาพภาพมากขึ้น
          โดยอ้างอิงจากการของขายในระบบ Message ของ Facebook <br />
          ร้านค้าสามารถกำหนดสถานะของออเดอร์และมูลค่าที่ต้องการได้ <br />
          ซึ่งการเก็บข้อมูลนั้นจะเกิดขึ้นได้เพียงออเดอร์ละ 1 ครั้งเท่านั้น  <br />
          ระบบจะนำข้อมูลดังกล่าวไป optimize ให้การซื้อโฆษณานั้นตรงกลุ่มเป้าหมาย  <br />
          มากยิ่งขึ้น
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    small: Boolean
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    setDialog (dialog = false) {
      this.dialog = dialog
    }
  }
}
</script>

<style lang="scss">
  .circle-number {
    color: #ffffff;
    height: 20px;
    width: 20px;
    min-width: 20px;
    border-radius: 50%;
    background-color: var(--v-woocommerce-base);
    text-align: center;
    margin-top: 2px;
    &--small {
      height: 16px;
      width: 16px;
      min-width: 16px;
      font-size: 12px;
      line-height: 16px;
    }
  }
  .icon-chevron {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  }
</style>
